import * as z from 'zod';

import LastFiveGamesSchema from './LastFiveGamesSchema';
import OtherInfoSchema from './OtherInfoSchema';
import OverviewSchema from './OverviewSchema';
import PreviousMeetingsSchema from './PreviousMeetingsSchema';
import SeasonStatisticsSchema from './SeasonStatisticsSchema';
import TopGoalscorersSchema from './TopGoalscorersSchema';
import VictoryProbabilitySchema from './VictoryProbabilitySchema';

const StatisticsTabResponseSchema = z.object({
  overview: OverviewSchema.nullable(),
  previousMeetings: PreviousMeetingsSchema.nullable(),
  victoryProbability: VictoryProbabilitySchema.nullable(),
  lastFiveGames: LastFiveGamesSchema.nullable(),
  topGoalscorers: TopGoalscorersSchema.nullable(),
  seasonStatistics: SeasonStatisticsSchema.nullable(),
  otherInfo: OtherInfoSchema.nullable(),
});

export default StatisticsTabResponseSchema;
